import React from 'react';
import LoadingIcon from '../../../../LoadingIcon';
import { MultiSelect } from 'react-multi-select-component';
import ErrorMessage from '../../../../ErrorMessage';
import ServiceService from '../../../../../Services/serviceService';

export default class ServiceMultiChoice extends React.Component {
  static defaultProps = {
    className: '',
    onChange: () => alert('ServiceMultiChoice Onchange'),
    selected: [],
    fieldName: '',
    idFilter: '',
    filterCleared: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      itemList: [],
      selected: null,
    };
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.idFilter !== prevProps.idFilter) {
      this.populateListData();
    }

    if (this.props.filterCleared !== prevProps.filterCleared) {
      this.setState({ selected: [] });
    }
  }

  populateListData() {
    if (!this.props.idFilter) {
      this.setState({ selectValues: [] });
      return;
    }

    ServiceService.GetServiceListByOpportunityIds(this.props.idFilter)
      .then((result) => {
        let optValues = [];
        let selected = [];
        result.forEach((service) => {
          const newValue = {
            label: `${service.name} (${service.serviceId})`,
            value: service.serviceId,
          };
          optValues.push(newValue);

          if (this.props.selected && this.props.selected.some((x) => x.toString() == service.serviceId.toString())) {
            selected.push(newValue);
          }
        });
        this.setState({
          itemList: optValues,
          loading: false,
          selected: selected,
        });
      })
      .catch((error) => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('SMC67', error);
      });
  }

  multiSelectOnChange(selected) {
    this.setState({ selected: selected });
    this.props.onChange(selected.map((i) => i.value.toString()));
  }

  renderList() {
    return (
      <MultiSelect
        options={this.state.itemList}
        value={this.state.selected}
        onChange={this.multiSelectOnChange}
        labelledBy='Select'
      />
    );
  }

  render() {
    return (
      <div className={'text-center arial w-100 text-center hover rounded arial m-1 p-1'}>
        {this.state.loading ? (
          <LoadingIcon
            loading={true}
            className='h6'
          />
        ) : (
          this.renderList()
        )}
      </div>
    );
  }
}
